import { MS_PER_MINUTE } from './constants';
import type { Optional } from 'lib/types/Optional';

/** Whole minutes (rounded up) until the ISO `estimatedEndTime`; undefined when it's missing or invalid. */
export const getMinutesLeft = (estimatedEndTime: Optional<string>, nowMs: number): number | undefined => {
  if (!estimatedEndTime) {
    return undefined;
  }

  const endMs = new Date(estimatedEndTime).getTime();

  if (Number.isNaN(endMs)) {
    return undefined;
  }

  return Math.max(Math.ceil((endMs - nowMs) / MS_PER_MINUTE), 0);
};
